module.exports = __webpack_public_path__ + "img/vertical_6_2_9016.b09d7c12.png";